<template>
  <div class="h-svh relative" :style="appStyle">
    <NuxtPage
      :class="{
        'xl:px-52 px-4 sm:px-6 md:px-12 lg:px-16': !isAdminPage,
        'sm:pt-6 pt-3': !isAdminPage && showCategoriesBar,
      }"
      :transition="pageTransition"
    />

    <!-- Left padding clickable area - positioned above content -->
    <!-- Right padding clickable area - positioned above content -->

    <!-- <div
      class="hidden xl:block blur-3xl fixed w-full h-full left-0 top-0 bottom-0 bg-green-200/20 cursor-pointer -z-20"
      @click="handleBackdropClick"
    /> -->

    <!-- 
    <div
      class="hidden xl:block fixed right-0 top-0 bottom-0 w-72 cursor-pointer z-20"
      @click="handleBackdropClick"
    /> -->
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const { showCategoriesBar, contentFontFamily, builderUiFontFamily } = useTheme()
const { useBrandFontForUi } = useBuilderFeatures()
const isYuzuRoute = route.path === '/v2' || route.path.startsWith('/v2/')
const isYuzuPreview =
  route.path === '/v2/preview' || String(route.query.preview || '') === '1'
if (isYuzuRoute && !isYuzuPreview) useYuzuHostBridge()
useFonts()

const appStyle = computed(() => {
  return {
    ...createGiftieContentFontVariables(contentFontFamily.value),
    ...(useBrandFontForUi.value && builderUiFontFamily.value
      ? { fontFamily: builderUiFontFamily.value }
      : {}),
  }
})

const disableTransition = computed(
  () => String(route.query.disableTransition || '') === '1',
)

const defaultPageTransition = { name: 'fade', mode: 'out-in' as const }
const pageTransition = computed(() =>
  disableTransition.value ? false : defaultPageTransition,
)

// Check if current page is an admin page
const isAdminPage = computed(() => {
  return (
    route.path.startsWith('/admin') || route.path.startsWith('/shopify/variant')
  )
})

// const handleBackdropClick = () => {
//   // Only close if in iframe
//   if (import.meta.client && isInIframe()) {
//     notifyClose()
//   }
// }
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
